function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
//Material imports
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import withStyles from "@mui/styles/withStyles";
import Popper from "@mui/material/Popper";
//Limitless imports
import HeaderIconButton from "../buttons/header-icon-button/HeaderIconButton";
import { useHelpDrawer, useGuideDrawer } from "../..";
const IconMenu = ({
  classes,
  children,
  id,
  tooltip,
  ariaLabel,
  icon,
  iconColor,
  placement,
  dialogs,
  paperClass
}) => {
  const {
    isDrawerOpen,
    toggleHelpDrawer
  } = useHelpDrawer();
  const {
    isGuideOpen,
    toggleGuide
  } = useGuideDrawer();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  React.useEffect(() => {
    if (open && isDrawerOpen) {
      toggleHelpDrawer();
    }
    if (open && isGuideOpen) {
      toggleGuide();
    }
  }, [open]);
  const handleToggle = () => {
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
  };
  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }
  const menuClasses = {};
  if (placement === "bottom-end") {
    menuClasses.paper = classes.profilePaper;
    menuClasses.popperOpen = classes.profilePopperOpen;
    menuClasses.popperClose = classes.profilePopperClose;
    menuClasses.transformOrigin = "0 0 0";
  } else {
    menuClasses.paper = classes.paper;
    menuClasses.transformOrigin = "bottom left";
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderIconButton, {
    iconButtonRef: anchorRef,
    buttonId: id,
    onButtonClick: handleToggle,
    tooltip: tooltip,
    ariaLabel: ariaLabel,
    icon: icon,
    color: iconColor
  }), anchorRef.current && /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorEl: anchorRef.current,
    transition: true,
    disablePortal: true,
    className: open && placement === "bottom-end" ? menuClasses.popperOpen : menuClasses.popperClose,
    style: {
      left: "unset"
    }
  }, ({
    TransitionProps
  }) => /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
    style: {
      transformOrigin: menuClasses.transformOrigin
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: clsx(menuClasses.paper, paperClass)
  }, /*#__PURE__*/React.createElement(MenuList, {
    id: "menu-list-grow",
    onKeyDown: handleListKeyDown,
    onClick: handleClose
  }, children))))), dialogs);
};
const styles = {
  profilePopperClose: {
    pointerEvents: "none",
    top: "2px !important",
    position: "relative !important",
    left: "unset !important"
  },
  profilePopperOpen: {
    top: "2px !important",
    position: "relative !important",
    left: "unset !important",
    right: 16,
    transform: "none !important"
  },
  popper: {
    position: "relative !important",
    left: "unset !important"
  },
  profilePaper: {
    position: "absolute",
    right: 7,
    zIndex: 9999
  },
  paper: {
    position: "absolute",
    left: -25,
    bottom: 50,
    zIndex: 9999
  }
};
export default withStyles(styles)(IconMenu);
IconMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
  dialogs: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  id: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  tooltip: PropTypes.string.isRequired,
  icon: PropTypes.node,
  iconColor: PropTypes.string.isRequired,
  placement: PropTypes.string.isRequired,
  paperClass: PropTypes.string
};